import React from "react";
import { Form, Formik } from "formik";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  addStore,
} from "../../../../redux/Thunk/Store/StoreThunks";
import Button from "../../../common/Button";
import Address from "./Address";
import Compliances from "./Compliances";
import Contact from "./Contact";
import Location from "./Location";
import PrimaryDetails from "./PrimaryDetails";
import SelectedTab from "../../../common/SelectedTab";
import { UserCreateMenu } from "../../../../utils/constants";
import { setActiveForm } from "../../../../redux/Reducer/Admin/PartnerSlice";
import { createStoreValidation } from "../../../common/Validation/createOrderValidation";
import toast from "react-hot-toast";
import Loader from "../../../Loader";

const NewStore = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector(
    ({ store }) => ({
      loading: store?.loading,
    }),
    shallowEqual
  );
  const initialValues = {
    storeDetails: {
      SID: "",
      title: "",
      username: "",
      pin: "",
    },
    compliances: {
      gstin: "",
      dln: "",
      fssaiNo: "",
    },
    address: {
      premisesNo: "",
      floor: "",
      premisesName: "",
      landmark: "",
      areaRoad: "",
      city: "",
      pinCode: "",
      state: "",
      phoneNumber: "",
    },
    location: {
      googleMapUrl: "",
    },
    contact: {
      contactNo: "",
      email: "",
      email2: "",
    },
    billing: {
      applyAll: false,
      smallCartFee: {
        charges: 0,
        applyBelow: 0,
        enable: false,
      },
      handlingFee: {
        charges: 0,
        applyBelow: 0,
        enable: false,
      },
      deliveryChargesSameCity: {
        charges: 0,
        applyBelow: 0,
        enable: false,
      },
      deliveryChargesSameState: {
        charges: 0,
        applyBelow: 0,
        enable: false,
      },
      deliveryChargesOtherState: {
        charges: 0,
        applyBelow: 0,
        enable: false,
      },
      noDiscount: {
        percentage: 0,
        applyBelow: 0,
        enable: false,
      },
    },
  };
  const handleStoreSubmit = async (values, { resetForm }) => {
    if (!values.storeDetails.SID) {
      delete values.storeDetails.SID;
    }
    let gst = values?.compliances?.gstin;
    values.compliances.gstin = gst.trim() === "" ? null : gst.trim();
    try {
      const response = await dispatch(addStore(values)).unwrap();
      if (response.status === 201) {
        resetForm();
      } else {
        if (response?.response?.data?.error === "Username already exists.") {
          handleFocus("storeDetails.username");
          toast.error("Username already exist!!");
        } else if (
          response?.response?.data?.error ===
          "GST number already exists in the system."
        ) {
          handleFocus("compliances.gstin");
          toast.error("GST number already exists in the system.");
        } else {
          if (response.status === 409) {
            toast.error(response?.response?.data?.error);
          } else {
            toast.error(response?.message);
          }
        }
      }
    } catch (error) {
      console.error("Error creating doctor:", error);
      toast.error("An error occurred while creating the account.");
    }
  };
  const handleFocus = (feild) => {
    if (feild === "storeDetails.username") {
      const inputField = document.getElementById("username");
      inputField?.focus();
    } else if (feild === "compliances.gstin") {
      const inputField = document.getElementById("gst");
      inputField?.focus();
    }
  };
  // const formik = useFormik({
  //   initialValues: {
  //     storeDetails: {
  //       SID: "",
  //       title: "",
  //       username: "",
  //       pin: "",
  //     },
  //     compliances: {
  //       gstin: "",
  //       dln: "",
  //       fssaiNo: "",
  //     },
  //     address: {
  //       premisesNo: "",
  //       floor: "",
  //       premisesName: "",
  //       landmark: "",
  //       areaRoad: "",
  //       city: "",
  //       pinCode: "",
  //       state: "",
  //       phoneNumber: "",
  //     },
  //     location: {
  //       googleMapUrl: "",
  //     },
  //     contact: {
  //       contactNo: "",
  //       email: "",
  //       email2: "",
  //     },
  //   },
  //   validationSchema: createStoreValidation,
  //   onSubmit: handleStoreSubmit,
  //   validateOnChange: true,
  // });
  // useEffect(() => {
  //   dispatch(fetchStores());
  // }, [dispatch]);

  // useEffect(() => {
  //   if (!storeById || !Object.keys(storeById)?.length) {
  //     return;
  //   }

  //   const storeDetails = storeById;
  //   formik.setValues({
  //     storeDetails: {
  //       SID: storeDetails?.SID || "",
  //       title: storeDetails?.title || "",
  //       username: storeDetails?.username || "",
  //       pin: storeDetails?.pin || "",
  //     },
  //     compliances: {
  //       gstin: storeDetails?.storeCompliance?.gstin || "",
  //       dln: storeDetails?.storeCompliance?.dln || "",
  //       fssaiNo: storeDetails?.storeCompliance?.fssaiNo || "",
  //     },
  //     address: {
  //       premisesNo: storeDetails?.address?.premisesNo || "",
  //       floor: storeDetails?.address?.floor || "",
  //       premisesName: storeDetails?.address?.premisesName || "",
  //       landmark: storeDetails?.address?.landmark || "",
  //       areaRoad: storeDetails?.address?.areaRoad || "",
  //       city: storeDetails?.address?.city || "",
  //       pinCode: storeDetails?.address?.pinCode || "",
  //       state: storeDetails?.address?.state || "",
  //       phoneNumber: storeDetails?.address?.phoneNumber || "",
  //     },
  //     location: {
  //       googleMapUrl: storeDetails?.location?.googleMapUrl || "",
  //     },
  //     contact: {
  //       contactNo: storeDetails?.contact?.contactNo || "",
  //       email: storeDetails?.contact?.email || "",
  //       email2: storeDetails?.contact?.email2 || "",
  //     },
  //   });
  // }, [storeById]); // Make sure it triggers whenever storeById changes

  return (
    <>
      <section className="tab-store">
        <Loader loading={loading} />
        <SelectedTab tabs={UserCreateMenu} index={2} />
        {/* <form className="dashboard-container" onSubmit={formik.handleSubmit}> */}
        <Formik
          initialValues={initialValues}
          onSubmit={handleStoreSubmit}
          validationSchema={createStoreValidation}
          validateOnChange={true}
        >
          {({
            values,
            setValues,
            resetForm,
            handleChange,
            setFieldValue,
            touched,
            errors,
            setFieldTouched,
            handleBlur,
            setFieldError,
          }) => {
            return (
              <Form className="dashboard-container">
                <div className="bg-gray-100 py-3 px-5 rounded-[12px] mb-4">
                  <span className="pb-4 font-poppins font-medium text-[25px] leading-[30px]">
                    Create Store Account
                  </span>
                  <PrimaryDetails
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldTouched={setFieldTouched}
                  />
                  <Compliances
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldTouched={setFieldTouched}
                  />
                  <Address
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldTouched={setFieldTouched}
                  />
                  <Location
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldTouched={setFieldTouched}
                  />
                  <Contact
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldTouched={setFieldTouched}
                  />
                  <div className="pt-2 flex items-center gap-2">
                    <Button
                      className="bg-primary-600 h-[36px] text-white py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 hover:bg-primary-200 hover:border-primary-200 focus:border-primary-200 border-[4px] border-primary-600 shadow-none outline-none"
                      type="submit"
                      // onClick={handleStoreSubmit}
                    >
                      Register Store
                    </Button>
                    <Button
                      className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                      type="button"
                      onClick={() => dispatch(setActiveForm(null))}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </section>
    </>
  );
};

export default NewStore;
